import { createAction } from '@reduxjs/toolkit';
import { createAsyncAction } from 'services/actionConfigs';
import { IApiGetDemoDataParam, IApiGetListScreensInStoreParam, IApiGetListStoresParam, ICreateStoreRequest } from '../interfaces/api';
import { PREFIX_ACTIONS } from './constants';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const createStore = createAsyncAction<ICreateStoreRequest>(PREFIX_ACTIONS + 'createStore');
const getListStores = createAsyncAction<IApiGetListStoresParam>(PREFIX_ACTIONS + 'getListStores');
const setListStoresParams = createAction<IApiGetListStoresParam>(PREFIX_ACTIONS + 'setListStoresParams');
const getListScreensInStore = createAsyncAction<IApiGetListScreensInStoreParam>(PREFIX_ACTIONS + 'getListScreensInStore');

const storeActions = {
  getDemoData,
  createStore,
  getListStores,
  setListStoresParams,
  getListScreensInStore,
};

export default storeActions;

